import React from "react";
import { Typography } from "@material-ui/core";
import { Editor } from "@tinymce/tinymce-react";
import { CustomBorder } from "src/components/layout/CustomBorder";

interface Props {
  value: any;
  height: number;
  onChange?: any;
  name: string;
  showHeader?: boolean;
  notesError?: boolean;
  title?: string;
  required?: boolean;
  notesHelperText?: string | "";
  disabled?: boolean;
  noShowHeaderBorder?: boolean;
  customColor?: string;
}

const CommonTextEditor = ({
  value,
  onChange,
  height,
  name,
  notesError = false,
  showHeader,
  required,
  title,
  notesHelperText = "",
  disabled = false,
  noShowHeaderBorder = false,
  customColor,
}: Props) => {
  return (
    <>
      {showHeader && (
        <>
          <Typography
            style={{
              marginTop: 0,
              color: notesError ? "red" : customColor ? customColor : "inherit",
            }}
          >
            {required ? `${title}*` : title}
          </Typography>
          {!noShowHeaderBorder && <CustomBorder mt={0.5} mb={2} />}
        </>
      )}
      <Editor
        value={value}
        disabled={disabled}
        onEditorChange={(e) => {
          onChange &&
            onChange({
              target: { name, value: e },
            });
        }}
        scriptLoading={{ async: true, delay: 1 }}
        apiKey="rvgse59zqtsv1dief7jv1z4vt7h5zcg6g4bjqpb7pzn81bgh"
        init={{
          height: height || 200,
          menubar: false,
          plugins: [
            // "advlist autolink lists link image charmap print preview anchor",
            // "searchreplace visualblocks code fullscreen",
            // "insertdatetime media table paste code help wordcount",
            "table",
          ],
          toolbar:
            // "undo redo | formatselect | " +
            "undo redo | fontselect | fontsizeselect | " +
            "bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help" +
            "tableprops table tabledelete",
          // "| tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol",
          fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt",
          font_formats:
            "Arial=arial,helvetica,sans-serif; Courier New=courier new,courier,monospace; AkrutiKndPadmini=Akpdmi-n; Verdana=verdana",
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
      {notesError && (
        <Typography
          style={{
            fontSize: 10,
            marginLeft: 10,
            color: "red",
            marginTop: "1px",
            marginBottom: 5,
          }}
        >
          {notesHelperText}
        </Typography>
      )}
    </>
  );
};

export default CommonTextEditor;
